import { render, staticRenderFns } from "./join-us.vue?vue&type=template&id=3b2fe20b&scoped=true"
import script from "./join-us.vue?vue&type=script&lang=js"
export * from "./join-us.vue?vue&type=script&lang=js"
import style0 from "./join-us.vue?vue&type=style&index=0&id=3b2fe20b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fe20b",
  null
  
)

export default component.exports